module.exports = __webpack_public_path__ + "static/media/emoticon.5b2b8966.svg";